import httpClient from './_httpClient';

const uploadAttachment = (scope_id, entity_type, entity_id, attachment, onUploadProgress) => {
  let formData = new FormData();

  formData.append("file", attachment);
  return httpClient.post(
    "/scopes/" + scope_id + "/" + entity_type + "/" + entity_id + "/attachments",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data"
      },
      onUploadProgress
    });
  };

const deleteAttachment = (scope_id, entity_type, entity_id, attachment_id) => httpClient.delete("/scopes/" + scope_id + "/" + entity_type + "/" + entity_id + "/attachments/" + attachment_id);

export {
  uploadAttachment,
  deleteAttachment
}
